import React from 'react';
import { Link } from "react-router-dom";
import { FiArrowRight } from "react-icons/fi";
import SEO from "../common/SEO";
import HeaderTwo from '../common/header/HeaderTwo';
import HeaderTopBar from '../common/header/HeaderTopBar';
import TabThree from '../elements/tab/TabThree';
import Slider from "react-slick";
import { BannerActivation } from "../utils/script";
import SectionTitle from "../elements/sectionTitle/SectionTitle";
import SlpitOne from "../elements/split/SlpitOne";
import ServiceOne from "../elements/service/ServiceOne";
import FooterTwo from '../common/footer/FooterTwo';
import Copyright from '../common/footer/Copyright';
import Separator from "../elements/separator/Separator";
import AboutThree from '../elements/about/AboutThree';
import { useTranslation } from "react-i18next";
import TypewriterComponent from 'typewriter-effect';

const MainPage = () => {
    const { t } = useTranslation('enterprise');
    const BannerData = [
        {
            image: t('home.img3'),
            title: t('home.title3'),
            description: t('home.subtitle3'),
        },
        {
            image: t('home.img2'),
            title: t('home.title2'),
            description: t('home.subtitle2'),
        },
        {
            image: t('home.img4'),
            title: t('home.title4'),
            description: t('home.subtitle4'),
        },
        {
            image: t('home.img1'),
            title: t('home.title'),
            description: t('home.subtitle'),
        },
    ]
    
    return (
        <>
            <SEO title="N01ZET Enterprise - Recognition and Rewards Saas Platform for Emoployees and Stakeholders" />
            <main className="page-wrapper main-mobile-responsive">
                <HeaderTopBar />
                <HeaderTwo btnStyle="btn-small btn-icon" HeaderSTyle="header-transparent" />
                {/* Start Slider Area  */}
                <Slider className="slider-area slider-style-4 slider-dot rn-slick-dot rn-slick-arrow" {...BannerActivation}>
                    {BannerData.map((data, index) => (
                        <div key={index} className="single-slide">
                            <div className="height-950 bg-overlay bg_image" >
                                <div className="container">
                                    <div className="row row--30 align-items-center">
                                        <div className="order-2 order-lg-1 col-lg-6">
                                            <div className="inner text-left">
                                                <h1 className="title cust-title"><TypewriterComponent
                                                options={{
                                                    strings: (data.title),
                                                    autoStart: true,
                                                    loop: true,
                                                  }} 
                                                onInit={(slidertype) => {
                                                    slidertype
                                                    .pauseFor(1000)
                                                    .start();
                                                }}
                                                /></h1>
                                                <p className="description" dangerouslySetInnerHTML={{__html: data.description}}></p>
                                                <div className="button-group">
                                                    <Link className="btn-default btn-medium btn-icon" to="/offers">{t('footer.offres')}<i className="icon"><FiArrowRight /></i></Link>
                                                    <Link className="btn-default btn-medium btn-border btn-icon cust-color" to="/contact">{t('buttons.beContacted')}<i className="icon"><FiArrowRight /></i></Link>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="order-2 order-lg-1 col-lg-6">
                                            <img style={{ marginLeft: '80px', marginTop: '80px' }} className="bannerimg" alt="slides" src={`${data.image}`}/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </Slider>
                {/* End Slider Area  */}    

                {/* Start Service Area  */}
                <div className="rn-service-area rn-section-gap ">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <SectionTitle
                                    textAlign="text-center"
                                    radiusRounded=""
                                    subtitle=""
                                    title={t('home.principe')}
                                    description={t('home.principeSubtitle')}
                                />
                            </div>
                        </div>
                        <ServiceOne
                            serviceStyle="service__style--1 bg-color-blackest radius mt--20 rbt-border"
                            textAlign="text-left"
                        />
                    </div>
                </div>
                {/* End Service Area  */}

                <Separator />
                
                {/* Start One-stop shop Area  */}
                <div className="rwt-tab-area rn-section-gap">
                    <div className="container">
                        <div className="row mb--40">
                            <div className="col-lg-12">
                                <SectionTitle
                                    textAlign = "text-center"
                                    radiusRounded = ""
                                    subtitle = ""
                                    title = {t('home.offresTitle')}
                                    description = {t('home.offresSubtitle')}
                                />
                            </div>
                        </div>
                        <TabThree />
                    </div>
                </div>
                {/* End One-stop shop Area  */}


                <Separator />
                {/* Start Security Area  */}
                <div className="rwt-split-area no-radius">
                    <div className="wrapper">
                        <SlpitOne />
                    </div>
                </div>
                {/* End Security Area  */}
                <Separator />
                
                <Separator />
                <AboutThree />

                <FooterTwo />
                <Copyright />
            </main>
        </>
    )
}

export default MainPage
